<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title
                >{{ `${$route.meta.title}` | t
                }}<span style="color:gray;">{{ ` (${unmatchedShopsCount})` }}</span></v-toolbar-title
            >
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" />

        <!--    Right drawer    -->
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="800">
            <unmatched-shops-view v-if="$route.name === 'unmatched-shops-view'" />
        </v-navigation-drawer>
        <!-- Main content -->
        <v-main>
            <router-view />
        </v-main>

        <!-- Footer -->
        <page-footer />

        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Store from "../store";
import UnmatchedShopsView from "../pages/unmatched-shops/unmatched-shops-view";

export default {
    name: "unmatched-shops",
    components: {
        PageFooter,
        MainDrawer,
        UnmatchedShopsView
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
        await this.fetchCountries();
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        ...mapActions(["fetchCountries"]),
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.mainDrawerOpen) {
                this.$router.push({ name: "unmatched-shops-list" });
            }
            if (
                this.activeUnmatchedShop &&
                Object.keys(this.activeUnmatchedShop).length > 0 &&
                document.activeElement.tagName !== "INPUT"
            ) {
                //Store.commit("UnmatchedShopsStore/resetNewShopData");
                let currentUserIndex = this.unmatchedShops.findIndex(p => p.id === this.activeUnmatchedShop.id);
                if (e.key === "ArrowUp") {
                    if (currentUserIndex !== 0) {
                        const newShop = this.unmatchedShops[currentUserIndex - 1];
                        Store.dispatch("UnmatchedShopsStore/getUnmatchedShopsData", {
                            invoiceId: newShop.id,
                            invoiceType: newShop.type
                        });
                        this.$router.push({
                            name: this.$route.name,
                            params: { invoiceId: newShop.id, invoiceType: newShop.type }
                        });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentUserIndex + 1 !== this.unmatchedShops.length) {
                        const newShop = this.unmatchedShops[currentUserIndex + 1];
                        Store.dispatch("UnmatchedShopsStore/getUnmatchedShopsData", {
                            invoiceId: newShop.id,
                            invoiceType: newShop.type
                        });
                        this.$router.push({
                            name: this.$route.name,
                            params: { invoiceId: newShop.id, invoiceType: newShop.type }
                        });
                    }
                }
            }
        }
    },
    computed: {
        ...mapState("UnmatchedShopsStore", ["drawerOpen", "requestSuccess", "activeUnmatchedShop", "unmatchedShops"]),
        ...mapGetters("UnmatchedShopsStore", ["unmatchedShopsCount"])
    }
};
</script>

<style scoped>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}
</style>
